<mat-chip-listbox aria-label="Anno Scolastico">
  <mat-chip-option *ngFor="let year of scholasticYears" (click)="onSelect(year)" [selected]="year == selectedYear"
    [ngClass]="year == selectedYear ? 'text-light fw-bold dea-mat-chip-option selected' : ''">
    {{year}}
  </mat-chip-option>
  <div *ngIf="scholasticYears.length == 0" class="h-100 d-flex align-content-center"
    style="margin-top: 0.7rem; min-height: 29px;">
    <mat-icon><mat-spinner diameter="18"></mat-spinner></mat-icon>
  </div>
</mat-chip-listbox>
